var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('header',{staticClass:"header"},[_c('AppHeader')],1),_c('main',{staticClass:"main"},[_c('router-view')],1),(!_vm.$store.getters['auth/isIntegration'])?_c('footer',[(_vm.isExperian)?_c('ExperianFooter'):_c('AppFooter')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }